import TextInputColumnFilter from "../../../shared/table/TextInputColumnFilter";

export const TABLE_COLUMNS = [
  {
    Header: "Product Name",
    accessor: "description",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Actions",
    id: "Actions",
  },
];
